import { AsyncViewProcessor, tools, LightAppUtil, emitter, Toast } from 'tplus-voucher';
import { webapiProxyReq } from '../../api/TplusApi';
import {
  action,
  history
} from 'mutants-microfx';

import { NavUtils } from 'mutants-mobile-navigator';




//编辑单据
export default class AttachmentEditSaledeliveryDocProcessor extends AsyncViewProcessor {


  async doExecute(index) {
    const id = this.getVoucherDataByFieldName('ID');
    const AttachmentRead = this.getVoucherDynamicValueByFieldName('AttachmentRead');
    const AttachmentEdit = this.getVoucherDynamicValueByFieldName('AttachmentEdit');
    const IsBeforeSystemInuse = this.getVoucherDataByFieldName('IsBeforeSystemInuse') // 是否是期初销货单

    console.log(AttachmentRead, AttachmentEdit)

    if (id) {
      console.log('点击附件id => ', id);
      setLoading(true, '附件信息获取中...');
      const method = 'Ufida.T.EAP.Interface.IAttachmentUploadService.MBGetAttachment';
      try {
        const resp = await webapiProxyReq({
          voucherId: id,
          businessCode: IsBeforeSystemInuse ? 'SYS0921' : this.mid
        }, method, false);
        if (resp.Code == 0) { // 请求成功
          let Data = resp.Data;
          let { images, docs } = (Data && Data!='null') ? JSON.parse(Data) : { images: [], docs: [] };
  
          NavUtils.pushForResult('/attachment', {
            action: AttachmentEdit ? 'edit' : '', // 判断是否有编辑附件的权限
            imageMaxSize: 9,
            imageRowLenght: 3,
            images: images,
            docs: docs
          }, this.pageBackReceiveResult.bind(this));
        } else {
          alert(resp.Msg.text);
        }
      } catch (err) {
        console.error('获取附件信息异常 >> ',err);
      } finally{
        setLoading(false);
      }
    }
  }

  async pageBackReceiveResult(action, {images, docs}) {
    const id = this.getVoucherDataByFieldName('ID');
    const AttachmentRead = this.getVoucherDynamicValueByFieldName('AttachmentRead');
    const AttachmentEdit = this.getVoucherDynamicValueByFieldName('AttachmentEdit');
    const IsBeforeSystemInuse = this.getVoucherDataByFieldName('IsBeforeSystemInuse') // 是否是期初销货单
    if (action == 'attachment' && AttachmentEdit) {
      // 保存 result
      setLoading(true, '附件信息保存中...');
      const method = 'Ufida.T.EAP.Interface.IAttachmentUploadService.MBAttachmentHandle';
      try{
        const resp = await webapiProxyReq({
          jsonStr: JSON.stringify({
            voucherId: id,
            businessCode: IsBeforeSystemInuse ? 'SYS0921' : this.mid,
            sourceType: 'MB',
            images: images,
            docs: docs
          })
        }, method, false);
        if (resp.Code == 0) {
          Toast.info('附件保存成功', 1);
          // emitter.emit('loadView', { pid: this._pid });
          if (this.mid == 'SA04') { // 销货单需要重新请求数据，销售订单不需要，他会在单据详情页面请求
            await this.loadData(id, { operateAction: '' });
          }
          emitter.emit('VoucherDetailFresh');
        } else {
          Toast.fail(resp.Msg.Text, 2);
        }
      }catch(err){
         console.error('附件信息保存异常 >> ',err);
        setLoading(false);
      }

    }
  }
}